import { useNavigate } from "react-router-dom";
import { ShieldCheck } from "lucide-react";
import AdminPanel from "@/components/AdminPanel";

const Forja = () => {
    const navigate = useNavigate();
    return (
        <section className="min-h-screen pb-24 pt-28 md:pt-36" data-testid="forja-page">
            <div className="zf-container max-w-xl">
                <div className="mb-8 text-center">
                    <ShieldCheck className="mx-auto h-10 w-10 text-forge-yellow" />
                    <h1 className="mt-3 font-display text-2xl font-bold uppercase text-forge-paper">Área do criador</h1>
                    <p className="mt-2 text-sm leading-relaxed text-forge-dim">
                        Acesso exclusivo do dono — os clientes não têm nenhum botão de administração no site.
                    </p>
                </div>
                <AdminPanel open={true} onOpenChange={(o) => { if (!o) navigate("/"); }} />
            </div>
        </section>
    );
};

export default Forja;
